import { __objRest, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/elements/Thumbnail/Thumbnail.tsx
import React, { forwardRef, useMemo } from "react";
import clsx from "clsx";
var THUMBNAIL_CLASSNAME_MAP = {
  size: {
    "2xs": "pd-thumbnail--2xs",
    xs: "pd-thumbnail--xs",
    sm: "pd-thumbnail--sm",
    md: "pd-thumbnail--md",
    lg: "pd-thumbnail--lg",
    xl: "pd-thumbnail--xl",
    "2xl": "pd-thumbnail--2xl"
  }
};
var Thumbnail = forwardRef((_a, ref) => {
  var _b = _a,
    {
      children,
      size = "md",
      button,
      className
    } = _b,
    rest = __objRest(_b, ["children", "size", "button", "className"]);
  const showButton = useMemo(() => ["md", "lg", "xl", "2xl"].includes(size), [size]);
  return /* @__PURE__ */React.createElement("figure", __spreadValues({
    ref,
    className: clsx("pd-thumbnail", THUMBNAIL_CLASSNAME_MAP.size[size], className)
  }, rest), children, showButton && button);
});
var Thumbnail_default = Thumbnail;
export { Thumbnail_default };